import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="pt-16 min-h-screen bg-[#F8FAFB] px-4">
      <section className="min-h-[calc(100vh-4rem)] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-7xl md:text-8xl font-bold text-gray-900 mb-4">404</h1>
          <h2 className="text-2xl font-clean text-gray-900 mb-2">Page Not Found</h2>
          <p className="text-gray-700 mb-10">Oops! The page you&apos;re looking for does not exist</p>

          <Link
            to="/"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-soft-pink to-soft-lavender text-white font-medium rounded-xl shadow-soft hover:shadow-lg hover:scale-105 transition-all duration-300 w-fit group"
          >
            <span className="material-icons mr-2 text-lg transition-transform duration-300 group-hover:-translate-x-1">
              arrow_back
            </span>
            Return Home
          </Link>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
